/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMarquee = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 16v2h8v-2h2V8h-2V6H8v2H6v8zm-2 2H4v2h2zm14 0h-2v2h2zM6 4H4v2h2zm14 0h-2v2h2zM4 8H2V2h6v2h8V2h6v6h-2v8h2v6h-6v-2H8v2H2v-6h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMarquee as Marquee };
